import translationData from "@alchemy_cms/admin/package/src/translations"
translationData.it = {
  allowed_chars: 'di %{count} caratteri',
  cancel: 'Annulla',
  cancelled: 'Annullato',
  click_to_edit: 'clicca per modificare',
  complete: 'Completato',
  element_dirty_notice: 'Questo elemento contiene delle modifiche non salvate. Vuoi veramenter chiuderlo?',
  help: 'Aiuto',
  ok: 'Ok',
  page_dirty_notice: 'Su questa pagina hai delle modifiche non salvate. Verranno perse se decidi di continuare.',
  page_found: 'Pagina trovata',
  pages_found: 'Pagine trovate',
  url_validation_failed: 'Formato URL non valido.',
  warning: 'Attenzione!',
  'File is too large': 'Il file è troppo grande',
  'File is too small': 'Il file è troppo piccolo',
  'File type not allowed': 'Tipo di file non consentito',
  'Maximum number of files exceeded': 'Numero massimo di file raggiunto.',
  'Uploaded bytes exceed file size': 'Il numero di byte caricati eccede la dimensione del file',
  formats: {
    datetime: "d-m-Y H:i",
    date: "d-m-Y",
    time: "H:i",
    time_24hr: false
  }
}